import _ from "lodash";
import React, { useEffect, useState } from "react";
import { PlusCircle, Trash } from "react-bootstrap-icons";
import { useSelector } from "react-redux";

function ObjectiveArray({ parentIndex, formData, onUpdate }) {
  let [data, setData] = useState(formData || []);

  function onAddClick() {
    setData([...data, ""])
  }

  function onDropIndexClick(index) {
    let items = [...data];
    items.splice(index, 1);

    setData([...items]);
  }

  function handleChange(index, value) {
    let items = [...data];

    items[index] = value;

    setData([...items]);
  }

  useEffect(() => {
    onUpdate(parentIndex, data);
  }, [JSON.stringify(data)]);

  return (
    <React.Fragment>
      <label className="form-label mb-0">Objectives for goal {parentIndex + 1}</label>
      {
        data.map((val, i) => {
          return (
            <React.Fragment key={`objective-${i}`}>
              <div className="py-2 px-2 px-md-3 p-md-2 clearfix prnf-addrow d-flex">
                <input type="text" className="form-control form" defaultValue={val} onBlur={(e) => handleChange(i, e.target.value)} />
                <button type="button" className="btn btn-link float-right del-btn inline-del-btn"
                  onClick={(e) => onDropIndexClick(i)}><Trash size={16} />
                </button>
              </div>
            </React.Fragment>
          );
        })
      }
      <div>
        <button type="button" className="btn btn-primary btn-sm btn-table-add-row" onClick={onAddClick}> Add Objective <i><PlusCircle size={17} /> </i></button>
      </div>
    </React.Fragment>
  )
}

function TPTreatmentGoalObjectives(props) {
  const { schema, uiSchema, formData, onChange } = props;
  const { title } = schema;
	const widget = _.get(uiSchema, 'ui:widget', "");

  let [data, setData] = useState(formData || []);

  let defaultValue = {
    therapy: "",
    objectives: [""]
  }

  useEffect(() => {
    if (_.isEmpty(data)) {
      setData([defaultValue]);
    }
  }, [JSON.stringify(data)])

  useEffect(() => {
    onChange(data);
  }, [JSON.stringify(data)]);

	if (widget === 'hidden') {
		return null;
	}
	
  function onObjectiveUpdate(index, value) {
    let items = [...data];

    items[index] = {
      ...items[index],
      objectives: value
    }

    setData(items);
  }

  function addGoal() {
    setData([...data, defaultValue]);
  }

  function removeGoal(index) {
    let items = [...data];
    items.splice(index, 1);

    setData(items);
  }

  function onGoalUpdate(index, value) {
    let items = [...data];

    items[index] = {
      ...items[index],
      therapy: value
    }

    setData(items);
  }


  return (
    <React.Fragment>
      <h4>{title}</h4>

      <div className="mb-4">
        {data.map((val, i) => {
          return (
            <React.Fragment key={`goal-${i}`}>
              <div className="tg-group">
                <div className="form-group">
                  <button type="button" className="btn btn-link float-right del-btn tg-group-delete" onClick={(e) => removeGoal(i)}><Trash size={16} /></button>
                  <label className="form-label">Treatment Goal {i + 1}</label>
                  <input type="text" className="form-control" defaultValue={val.therapy} onBlur={(e) => onGoalUpdate(i, e.target.value)} />
                </div>
                <div className="form-group pl-3">
                  <ObjectiveArray
                    parentIndex={i}
                    formData={val.objectives}
                    onUpdate={onObjectiveUpdate}
                  />
                </div>
              </div>
            </React.Fragment>
          )
        })}
        <button type="button" className="btn btn-primary btn-table-add-row" onClick={addGoal}> Add Goal <i><PlusCircle size={17} /> </i></button>
      </div>
    </React.Fragment>
  )
}

export default TPTreatmentGoalObjectives;